import React, { Component } from 'react';

import TEPAbout from "./threejs/threeEntryPoint";
import "./header.css";
//import './react-dat-gui.css';

//import DatGui, { DatBoolean, DatButton, DatNumber, DatString } from 'react-dat-gui';

export default class Header extends Component {
    ;

    constructor(props) {
      super(props);
      
  	}

    componentDidMount() {
        TEPAbout(this.threeRootElement);
    }
    componentWillReceiveProps({menuactive}) {
        this.setState({'menuactive': menuactive}, ()=>{
          document.getElementById('ele').setAttribute('animatestate',1);
          document.getElementById('ele').setAttribute('menuactive',menuactive);
        });
        
        //TEPAbout(this.threeRootElement,menuactive); 
  	}
    update = data => this.setState({ data })
    /*
    this.state = {
        data: {
          package: 'react-dat-gui',
          power: 9000,
          isAwesome: true,
          feelsLike: '#2FA1D6',
        }
      }
              <DatGui data={data} onUpdate={this.update}>
                <DatString path='package' label='Package' />
                <DatNumber path='power' label='Power' min={9000} max={9999} step={1} />
                <DatBoolean path='isAwesome' label='Awesome?' />
              </DatGui>
    */
    render () {
        //const { data } = this.state;
        return (
            <div id='ele' className="header-header" ref={element => this.threeRootElement = element} menuactive={this.props.menuactive} animatestate={0}>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/header/Header.js